import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetAutomationDetailRequestDto } from "../../dtos/get-automation-detail-request-dto";
import type { GetAutomationSummaryResponseDto } from "../../dtos/get-automation-summary-response-dto";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseGetAutomationSummaryQueryParams = {
  queryParams: GetAutomationDetailRequestDto;
  options?: Omit<UseQueryOptions<GetAutomationSummaryResponseDto>, "queryKey">;
};

export const useGetAutomationSummaryQuery = ({
  queryParams,
  options
}: UseGetAutomationSummaryQueryParams) => {
  return useQuery({
    queryKey: AutomationQueryKeys.getAutomationSummary(queryParams.id).queryKey,
    queryFn: async () =>
      await AutomationService.getAutomationSummary({ payload: queryParams }),
    ...options
  });
};
